import { capitalize } from 'lodash';

import { EscrowPartyTypeEnum } from 'src/graphql/schema';

import type { IEscrowInvitationQuery } from 'src/graphql/actions/escrow/escrowInvitation.query';
import type { IInvitationDetails } from 'src/widgets/EscrowInvitationDialog';

export const getInvitationDetails = ({
  appName,
  partyType,
  escrow,
}: IEscrowInvitationQuery['escrowInvitation']): IInvitationDetails => {
  const requestingParty = partyType === EscrowPartyTypeEnum.Depositor ? escrow.beneficiary : escrow.depositor;

  return {
    appName,
    productType: escrow.productType,
    role: capitalize(partyType),
    requester: requestingParty
      ? { name: requestingParty.companyName ?? '', logo: requestingParty.companyWebsite ?? '' }
      : null,
  };
};
